module.exports = __webpack_public_path__ + "assets/c4260c4f4938e84d12f2748a435ff21d.png";